import React from 'react';

import QuadralStepper from "@quadral/quadral-component-common/dist/components/stepper";
import QuadralAutocomplete from '@quadral/quadral-component-common/dist/components/autocomplete';
import QuadralDate from '@quadral/quadral-component-common/dist/components/date';
import QuadralButton from "@quadral/quadral-component-common/dist/components/button";

const purchaseOrderStatuses = [
    {
        sfId: "Nouvelle",
        title: "Nouvelle"
    },
    {
        sfId: "En cours",
        title: "En cours"
    },
    {
        sfId: "Livrée",
        title: "Livrée"
    }
];

const purchaseOrderCancelledStatus = "Annulée"
const purchaseOrderCancelledStatuses = [
    {
        sfId: "Nouvelle",
        title: "Nouvelle"
    },
    {
        sfId: purchaseOrderCancelledStatus,
        title: purchaseOrderCancelledStatus
    }
];

function formatDate(date) {
    if (!date) {
        return null;
    }
    const parsedDate = new Date(date);
    return parsedDate.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    });
}


export default function PurchaseOrderDetailsNew(props) {
    let purchaseOrder = props.purchaseOrder || {};

    const timelineStatuses = (purchaseOrder.status === purchaseOrderCancelledStatus) ? purchaseOrderCancelledStatuses : purchaseOrderStatuses;
    const activeStep = timelineStatuses.findIndex(status => status.sfId === purchaseOrder.status);

    const resetForm = () => {
        props.setFormData({
            expectedCompletionDate: purchaseOrder.expectedCompletionDate,
            expectedVisitDate: purchaseOrder.expectedVisitDate,
            customerComment: purchaseOrder.customerComment,
            additionalInformations: purchaseOrder.additionalInformations,
            applicant: purchaseOrder.applicant
        });

        props.setIsEditing(false);
    };

    const validateCommand = () => {
        if (!validateExecutionMode()) {
            console.log("Impossible de valider la commande car un mode d'exécution est 'À définir'");
        } else {
            props.validate();
        }
    };

    function validateExecutionMode() {
        return !props.diagnosticsFormData.some(diagnostic => diagnostic.executionMode === 'À définir');
    }

    return (
        <>
            <QuadralStepper
                activeStep={activeStep}
                steps={timelineStatuses.map(s => s.title)}
            />
            <div>
                <div md={6} lg={2}>
                    <h6 className='title-level-3'>Société</h6>
                    <p>{purchaseOrder.account?.name}</p>
                </div>
                <div md={6} lg={2}>
                    <h6 className='title-level-3'>Demandeur</h6>
                    {props.isEditing ? (
                        <QuadralAutocomplete
                            id="autocomplete-applicant"
                            name="applicant"
                            options={props.resultApplicant.map(c => c.name)}
                            value={props.formData.applicant?.name}
                            onInputChange={(event, newInputValue) => props.setValueApplicant(newInputValue)}
                            onChange={(event, newValue) => {
                                props.setValueApplicant(newValue || "");
                                if (newValue) {
                                    const selectedApplicant = props.resultApplicant.find(c => c.name === newValue);
                                    if (selectedApplicant) {
                                        props.handleField('applicant', selectedApplicant)
                                    } else {
                                        props.handleField('applicant', {id: '', name: newValue});
                                    }
                                }
                            }}
                            label="Demandeur"
                        />
                    ) : (
                        <p>{props.formData.applicant?.name !== null && props.formData.applicant?.name !== '' ? props.formData.applicant?.name : purchaseOrder?.applicant?.name} {props.formData.applicant?.email && ('(' + props.formData.applicant?.email + ')')}</p>
                    )}
                </div>
            </div>
            <div>
                <div md={6} lg={2}>
                    <h6 className='title-level-3'>Référence de commande</h6>
                    <p>{purchaseOrder.orderNumber}</p>
                </div>
                <div md={6} lg={2}>
                    <h6 className='title-level-3'>Référence client</h6>
                    <p>{purchaseOrder.customerReference}</p>
                </div>
                <div md={6} lg={2}>
                    <h6 className='title-level-3'>Diagnostiqueur</h6>
                    <p>{purchaseOrder.diagnostician?.name}</p>
                </div>
            </div>
            <form>
                <div className="c-mt-2">
                    <div md={4} lg={2}>
                        <h6 className='title-level-3'>Date de commande</h6>
                        <p>{formatDate(purchaseOrder.effectiveDate)}</p>
                    </div>
                    <div md={4} lg={2}>
                        <h6 className='title-level-3'>Date de réalisation attendue</h6>
                        {props.isEditing ? (
                            <QuadralDate
                                name="expectedCompletionDate"
                                value={props.formData.expectedCompletionDate}
                                disabled={!props.isEditing}
                                onChange={(value) => props.handleField('expectedCompletionDate', value)}
                            />
                        ) : (
                            <p>{formatDate(props.formData.expectedCompletionDate)}</p>
                        )}
                    </div>
                    <div md={4} lg={2}>
                        <h6 className='title-level-3'>Date de passage attendue</h6>
                        {props.isEditing ? (
                            <QuadralDate
                                name="expectedVisitDate"
                                value={props.formData.expectedVisitDate}
                                disabled={!props.isEditing}
                                onChange={(value) => props.handleField('expectedVisitDate', value)}
                            />
                        ) : (
                            <p>{formatDate(props.formData.expectedVisitDate)}</p>
                        )}
                    </div>
                    <div md={0} lg={6}/>
                    <div md={6} lg={4}>
                        <h6 className='title-level-3'>Commentaire</h6>
                        {props.isEditing ? (
                            <textarea
                                name="customerComment"
                                className="form-control"
                                style={{height: '50px'}}
                                value={props.formData.customerComment}
                                disabled={!props.isEditing}
                                onChange={(event) => props.handleField('customerComment', event.target.value)}
                            />
                        ) : (
                            <p>{props.formData.customerComment}</p>
                        )}
                    </div>
                    <div md={6} lg={4}>
                        <h6 className='title-level-3'>Informations à destination du diagnostiqueur</h6>
                        {props.isEditing ? (
                            <textarea
                                name="additionalInformations"
                                className="form-control"
                                style={{height: '50px'}}
                                value={props.formData.additionalInformations}
                                disabled={!props.isEditing}
                                onChange={(event) => props.handleField('additionalInformations', event.target.value)}
                            />
                        ) : (
                            <p>{props.formData.additionalInformations}</p>
                        )}
                    </div>
                    <div md={0} lg={2}/>
                    {props.canUpdate && (
                        <div md={3} lg={2}
                             className="d-flex flex-column c-gap-2 c-mt-2 align-items-center justify-content-center">
                            {props.isEditing ? (
                                <QuadralButton type="button" className="btn btn-secondary w-100"
                                               onClick={resetForm}>
                                    Annuler
                                </QuadralButton>
                            ) : (
                                <QuadralButton
                                    type="button"
                                    className={`btn btn-primary w-100 ${!validateExecutionMode() && 'disabled'}`}
                                    onClick={validateCommand}
                                    disabled={!validateExecutionMode()}
                                >
                                    Valider et envoyer au diagnostiqueur
                                </QuadralButton>
                            )}

                            {props.isEditing ? (
                                <QuadralButton type="button" className="btn btn-primary w-100"
                                               onClick={props.save}>
                                    Enregistrer
                                </QuadralButton>
                            ) : (
                                <>
                                    {props.canCancelOrder && (
                                        <QuadralButton type="button" className="btn btn-outline-primary w-100"
                                                       onClick={() => props.confirmation(props?.purchaseOrder)}>
                                            Annuler la commande
                                        </QuadralButton>
                                    )}
                                    <QuadralButton type="button" className="btn btn-primary w-100"
                                                   onClick={() => props.setIsEditing(true)}>
                                        Modifier
                                    </QuadralButton>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </form>
        </>
    );
}